<template>
<div class="main">
     <TopCtrl/>
    <div class="wrap" v-for="(d, index) in deliveries" :key="d.orderId">
        <div class="order-info">
            
            <template v-if="index <= 0">
                <div>
                    收件人：{{order.receiverName}}
                </div>
                <div>
                    联系方式：{{order.receiverPhone}}
                </div>
                <div>
                    收件地址：{{order.receiverAddress}}
                </div>
            </template>
            <div>
                京东单号：{{d.orderId}}
            </div>
        </div>
        <div class="detail-list">
            <div class="detail-item" v-for="detail in d.details" :key="detail.msgTime">
                <p class="content">{{detail.description}}</p>
                <div class="time">{{detail.msgTime}}</div>
            </div>
        </div>
    </div>
    <BottomAction text="返回订单" :link="'/pages/orders/detail?orderno='+$route.query.orderno"/>
</div>
</template>

<script>
import api from "../../api";


export default {
    title: '物流详情',
    bodyClass: 'gray-bg',
    components: {
    },
    data() {
        return {
            order: {
                receiverAddress:"",
                receiverName:"",
                receiverPhone:"",
                supplierName:"",
                supplierOrderno:""
            },
            deliveries:[
                {
                    "details":[
                        // {"description":"您提交了订单，请等待系统确认;操作人:客户","msgTime":"2018-08-07 11:24:06"},
                        // {"description":"您提交了订单，请等待系统确认;操作人:客户","msgTime":"2018-08-07 11:24:06"},
                        // {"description":"您提交了订单，请等待系统确认;操作人:客户","msgTime":"2018-08-07 11:24:06"}
                    ],
                    "orderId":""
                }
            ]
        }
    },
    methods: {
        gotoOrderDetail(){
            this.$routerReplace(this, '/pages/orders/detail?orderno='+this.$route.query.orderno);
        }
    },
    computed: {
        
    },
    mounted () {
        this.$showLoading('加载中...');
        var orderno = this.$route.query.orderno;
        api.order.getOrderDetail(orderno, res=>{
            console.log(res);
            this.order = res.order;
            
            api.order.getOrderDelivery(res.order.id, r=>{
                console.log(r);
                this.deliveries = r.deliveries;
                this.deliveries.forEach(d => {
                    if(d.details){
                        d.details.reverse();
                    }
                });
                this.$hideLoading();
            }, r=>{
                this.$alertDialog(r.msg);
                this.$hideLoading();
            });
        }, res=>{
            this.$alertDialog(res.msg);
            this.$hideLoading();
        });

    }
}
</script>
<style scoped lang="less">
    .order-info{
        background: #fff;
        padding: 4vw;
        color: #333;
        line-height: 1.5em;
        margin-bottom: 4vw;
        font-size: 3.733vw;
    }

    .detail-list{
        background: #fff;
        padding: 4vw;

        .detail-item{
            padding-left: 12vw;
            padding-top: 0vw;
            
            
            position: relative;
            z-index: 1;

            &:before{
                content: '';
                display: block;
                border-left: .2vw dashed #eee;
                position: absolute;
                z-index: 2;
                top: 0;
                bottom: -2vw;
                left: 6.5vw;
                width: 0;
            }

            &:after{
                position: absolute;
                z-index: 3;
                left: 5vw;
                top: 5.6vw;
                @size: 2.2vw;
                margin-left: .5vw;
                content: '';
                display: block;
                width: @size;
                height: @size;
                background: #eee;
                border-radius: 50%;
                border: none;
            }

            &:first-child{

                &:before{
                    top: 5vw;
                }
                
                &:after{
                    @size: 2.6vw;
                    content: '';
                    display: block;
                    width: @size;
                    height: @size;
                    left: 4.5vw;
                    top: 5vw;
                    background: #f23030;
                    border-radius: 50%;
                    border: @size/3 solid #fbc0c0;
                    margin:0;
                }   
            }

            &:last-child{

                .time{
                    border-bottom: none;
                }

                &:before{
                    height: 7vw;
                    bottom: auto;
                }
            }

            .content{
                font-size: 3vw;
            }

            .time{
                color: #999;
                font-size: 2.4vw;
                padding-bottom: 2vw;
                border-bottom: 1px solid #eee;
            }
        }

    }

    

</style>




// WEBPACK FOOTER //
// src/pages/orders/Logistics.vue